import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ReactTable } from "components/Table";
import Loading from "components/Loading";
import { loadUserTransaction, rollbackTransaction } from "actions/userActions";
import { formatterCreateAt, FormatterMoney, FormatterStatus } from "components/Function";

function Activity({ loadUserTransaction, formatterCreateAt, rollbackTransaction, user, FormatterStatus }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [totalSize, setTotalSize] = useState(50);
    const [searchText, setSearchText] = useState("");
    const { t } = useTranslation();
    const { email } = user.user;

    useEffect(() => {
        setLoading(true);
        loadUserTransaction({ page, sizeperpage: sizePerPage, search: searchText }).then((data) => {
            setData(data?.userTransaction || []);
            setTotalSize(data?.totalsize || 0);
            setLoading(false);
        });
    }, [loadUserTransaction, searchText, page, sizePerPage]);

    const handleRollback = async (transactionId) => {
        setLoading(true);
        const check = await rollbackTransaction(transactionId);
        if (check)
            await loadUserTransaction({ page, sizeperpage: sizePerPage, search: searchText }).then((data) => {
                setData(data?.userTransaction || []);
                setTotalSize(data?.totalsize || 0);
                setLoading(false);
            });
        setLoading(false);
    };

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "email",
            text: t("Email"),
            sort: true,
            formatter: (cell, row, rowIndex) => email,
        },
        {
            dataField: "amount",
            text: t("Balance Change"),
            sort: true,
            formatter: (cell, row, rowIndex) => {
                return (
                    <span
                        className={`text-${
                            ["auto_add", "add", "bonus"].includes(row.type) ? "success" : "danger"
                        }`}
                    >
                        <b><FormatterMoney money={cell} /></b>
                    </span>
                );
            },
        },
        {
            dataField: "method",
            text: t("Method"),
            sort: true,
            formatter: (cell, row, rowIndex) => t("System")
        },
        {
            dataField: "status",
            text: t("Status"),
            sort: true,
            formatter: (cell, row, rowIndex) => <FormatterStatus status={"completed"} />
        },
        {
            dataField: "balance",
            text: t("Balance"),
            sort: true,
            formatter: (cell, row, rowIndex) => {
                return (
                    <>
                        <p>{t("Before")}: <b><FormatterMoney money={row?.beforeBalance} /></b></p>
                        <p>{t("After")}: <b><FormatterMoney money={row?.afterBalance} /></b></p>
                    </>
                );
            },
        },
        {
            dataField: "note",
            text: t("Notes"),
            sort: true,
        },
        {
            dataField: "description",
            text: t("Content"),
            sort: true,
            formatter: (cell, row) => <span data-tooltip-id="my-tooltip" data-tooltip-html={cell.length > 60 ? `<div style="width: 200px">${cell}</div>` : ""}>{cell.length > 60 ? cell.substring(0, 60) + "..." : cell}</span>,
        },
        {
            dataField: "created_at",
            text: t("Created At"),
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "-",
            text: t("Actions"),
            formatExtraData: { page, sizePerPage, searchText },
            formatter: (cell, row, rowIndex, formatExtraData) => (
                <Fragment>
                    {row.type === "buy" && !row.rollbackStatus && (
                        <button
                            className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-2"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Rollback")}
                            onClick={() => handleRollback(row._id)}
                        >
                            <i className="ki-outline ki-arrows-circle fs-2"></i>
                        </button>
                    )}
                </Fragment>
            ),
        },
    ];

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalSize || 50,
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page || 1);
            setSizePerPage(sizePerPage);
        }
    };

    return (
        <Fragment>
            <Loading isLoading={loading} />
            <div className="card mb-5 mb-xl-10">
                <div className="card-body p-9">
                    <div className="al-variants-table">
                        <ReactTable
                            columns={columns}
                            data={data}
                            groupButton={<></>}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={sizePerPageList}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = { loadUserTransaction, formatterCreateAt, rollbackTransaction, FormatterStatus };

export default connect(mapStateToProps, mapDispatchToProps)(Activity);
